import { POST_STAFF_ERROR, POST_STAFF_START, POST_STAFF_SUCCESS } from '../../types';

export default function post_staff(state, action) {
  switch (action.type) {
    case POST_STAFF_START:
      return { ...state };
    case POST_STAFF_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_STAFF_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
